import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useEffect, useRef, useState } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import classes from "./Header.module.scss";
import ProfileDropdown from "./ProfileDropdown/ProfileDropdown";
import { useSelector } from "react-redux";

const Profile = () => {
  const settings = useSelector((state) => state.settings);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const wrapperMoreMenuRef = useRef(null);
  const [toggle, setToggle] = useOutsideClick(wrapperMoreMenuRef);

  const handleToggleDropdown = () => {
    setToggle(!toggle);
  };

  useEffect(() => {
    setTimeout(() => {
      setFirstName(localStorage.getItem("firstname"));
      setLastName(localStorage.getItem("lastname"));
    }, 300);
  }, [settings.isChangeProfileName]);

  return (
    <div
      className={classes.showHeader}
      ref={wrapperMoreMenuRef}
      style={{ position: "relative", marginRight: "10px" }}
    >
      <div
        className={toggle ? classes.headerButtonOpen : classes.headerButton}
        onClick={() => {
          handleToggleDropdown();
        }}
      >
        <span
          style={{
            marginRight: 5,
            marginLeft: 10,
            fontSize: 10,
          }}
        >
          <h6 className={classes.profileTitle}>{firstName + " " + lastName}</h6>
        </span>
        <span>
          {toggle ? (
            <ExpandLessIcon className={classes.icons} fontSize="small" />
          ) : (
            <ExpandMoreIcon className={classes.icons} fontSize="small" />
          )}
        </span>
      </div>
      <ProfileDropdown
        toggle={toggle}
        handleToggleDropdown={handleToggleDropdown}
      />
    </div>
  );
};

export default Profile;
